import { Image, StyleSheet, View, Text, Link } from "@react-pdf/renderer";
import { Fragment } from "react";

const LogoFooter = () => {
  const styles = StyleSheet.create({
    footer: {
      width: "100%",
      position: "relative",
      bottom: 0,
      height: 40,
      flexDirection: "row",
      marginTop: 10,
    },
    footerLeftBar: {
      width: "75%",
      backgroundColor: "#f48c32",
      color: "white",
      textAlign: "left",
      flexDirection: "row",
      alignItems: "center",
      paddingLeft: 15,
    },
    footerRightBar: {
      width: "25%",
      backgroundColor: "#333333",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      paddingLeft: 10,
    },
    footerIcons: {
      width: 25,
      height: 25,
      marginRight: 5,
      padding: 2,
    },
    footerImage: {
      width: 20,
      height: 20,
    },
    footerText: {
      fontSize: 10,
      color: "white",
    },

    feedback: {
      marginTop: 20,
      padding: 10,
      border: "1 solid #f7f7f7",
      backgroundColor: "#f7f7f7",
    },
    heading: {
      color: "#ed3338",
      fontSize: 14,
      fontWeight: "bold",
      marginBottom: 5,
    },
    paragraph: {
      fontSize: 12,
      marginBottom: 10,
    },
    row: {
      flexDirection: "row",
      padding: 10,
      alignItems: "center",
      justifyContent: "space-between",
    },
    column: {
      width: "45%",
      flexDirection: "row",
      alignItems: "center",
    },
    image: {
      width: 30,
      height: 30,
      marginRight: 10,
    },
    textBlock: {
      fontSize: 10,
    },
    link: {
      color: "blue",
      textDecoration: "underline",
      fontSize: 10,
    },
  });

  const FeedbackSection = () => (
    <View style={styles.feedback}>
      <Text style={styles.heading}>WE VALUE YOUR FEEDBACK!</Text>
      <Text style={styles.paragraph}>
        Your feedback is valuable to us and we look forward to hearing from you
        to improve our service levels. You may reach us in the following ways:
      </Text>
      <View style={styles.row}>
        <View style={styles.column}>
          <Image src="/cc-email.png" style={styles.image} />

          <View>
            <Text style={styles.textBlock}>Call our Customer Care at</Text>
            <Text style={styles.textBlock}>+91 22 71209091</Text>
          </View>
        </View>
        <View style={styles.column}>
          <Image src="/cc-mobile.png" style={styles.image} />

          <View>
            <Text style={styles.textBlock}>Write to us at</Text>
            <Link src="mailto:ppiphelpdesk@rbl.bank.com" style={styles.link}>
              ppiphelpdesk@rbl.bank.com
            </Link>
          </View>
        </View>
      </View>
    </View>
  );

  return (
    <Fragment>
      {/* <FeedbackSection /> */}
      <View style={styles.footer}>
        <View style={styles.footerLeftBar}>
          <Link
            href="https://www.facebook.com/PayCraftSolutions/"
            style={styles.footerIcons}
          >
            <Image style={styles.footerImage} src="/fb.png" alt="Facebook" />
          </Link>
          <Link
            href="https://www.linkedin.com/company/paycraftsolutions/"
            style={styles.footerIcons}
          >
            <Image
              style={styles.footerImage}
              src="/linkedin.png"
              alt="Linked in"
            />
          </Link>

          <Link href="https://x.com/PaycraftSol" style={styles.footerIcons}>
            <Image style={styles.footerImage} src="/x.png" alt="X" />
          </Link>

        </View>
        <View style={styles.footerRightBar}>
          <Link
            href="https://paycraftsol.com/"
            style={{ textDecoration: "none" }}
          >
            <Text style={styles.footerText}>paycraftsol.com</Text>
          </Link>
        </View>
      </View>
    </Fragment>
  );
};

export default LogoFooter;
